import { render, staticRenderFns } from "./PickupDetails.vue?vue&type=template&id=09a6e794&scoped=true&"
import script from "./PickupDetails.vue?vue&type=script&lang=ts&"
export * from "./PickupDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PickupDetails.vue?vue&type=style&index=0&id=09a6e794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6e794",
  null
  
)

export default component.exports